<template>
    <!--
        Formulario de Alta y Modificacion de mail 

        En caso de modificacion, itemSelected contiene el elemento y
        en caso de alta se debe cargar itemDataSelected.
    -->
    <div>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form @submit.prevent="submit">
                <v-row class="mt-5">
                    <v-col cols="12" md="12">
                        <ValidationProvider vid="confirmation" v-slot="v">
                            <v-text-field dense v-model="itemDataSelected.email" ref="emailref" autocomplete="off"
                                @input="itemDataSelected.email = itemDataSelected.email.toLowerCase()"
                                :error-messages="v.errors[0]" label="Correo electrónico"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12">
                        <ValidationProvider rules="email|required|confirmed:confirmation" v-slot="v">
                            <v-text-field dense v-model="confirmation" @paste="handlePaste" autocomplete="off"
                                :error-messages="v.errors[0]" label="Confirmar correo electrónico"
                                @input="confirmation = confirmation.toLowerCase()"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-select dense v-model="itemDataSelected.tipcontacto" :error-messages="v.errors[0]"
                                :items="tipoContacto" label="Tipo de contacto" item-value="tcnt_id"
                                item-text="tcnt_des_tipcontacto" @input="selectTipoContMail" return-object>
                            </v-select>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <ValidationProvider :rules="{}" v-slot="v">
                    <v-checkbox dense v-model="itemDataSelected.recibeemail" :error-messages="v.errors[0]" :true-value=1
                        :false-value=0 :readonly="(initialRecibeEmail)">
                        <template v-slot:label>
                            <div
                                :class="(itemDataSelected.recibeemail) ? `font-weight-medium primary--text` : `dark--text font-weight`">
                                Marcar como medio de contacto principal.
                            </div>
                        </template>
                    </v-checkbox>
                </ValidationProvider>
                <v-row>
                    <v-col class="text-end">
                        <v-btn type="submit" :disabled="invalid" color="primary" class="pa-5" elevation="0">
                            <v-icon class="mr-2">mdi-email-edit-outline</v-icon>
                            Guardar cambios
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </ValidationObserver>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            itemDataSelected: {
                id: '',
                nroafi: '',
                email: '',
                recibeemail: '',
                tipcontacto: '',
                destipcontacto: '',
                accion: ''
            },
            confirmation: '',
            modificacion: false,
            initialDesTipContacto: '',
            initialRecibeEmail: ''

        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.emailref.focus();
        });
        if (this.accion == 'modificar') {
            this.itemDataSelected = { ...this.itemSelected, accion: 'M' }
            this.initialRecibeEmail = this.itemDataSelected.recibeemail
            this.initialDesTipContacto = this.itemDataSelected.destipcontacto
        } else {
            this.itemDataSelected = {
                id: '',
                nroafi: '',
                email: '',
                recibeemail: 0,
                tipcontacto: '',
                destipcontacto: '',
                accion: 'A'
            }
        }
    },
    computed: {
        ...mapGetters('itemEdit', ['itemSelected']),
        ...mapGetters('common', ['tipoContacto']),
        ...mapGetters('auth', ['nroafi', 'isAuthenticated']),
        ...mapGetters(['email', 'hayEmailPrinc', 'emailPrinc']),

        tipoContactoFiltrado() {
            return this.tipoContacto.filter(item => !this.tipoContactoFiltro.includes(item.tcnt_des_tipcontacto))
        },

        confirmationToLowerCase() {
            return this.confirmation.toLowerCase()
        }
    },

    methods: {
        ...mapActions('common', ['getTipoContactoFiltro']),
        ...mapActions(['sendEmail', 'refreshItems']),
        ...mapActions('notificaciones', ['showSnack']),

        handlePaste(e) {
            e.preventDefault();
            this.showSnack({
                message: 'No esta permitido copiar y pegar',
                type: '500'
            })
        },

        //Rellena el campo de 'descripcion de tipo' con el 'id del tipo' que corresponde
        selectTipoContMail(value) {
            const tipoSeleccionado = value.tcnt_des_tipcontacto;
            // Verifica si ya existe ese tipo de contacto en otro mail (excluyendo el actual)
            const existe = this.email.some(
                e => e.destipcontacto === tipoSeleccionado && e.id !== this.itemDataSelected.id
            );
            if (existe) {
                this.showSnack({
                    message: `Ya existe el tipo ${tipoSeleccionado} que quiere seleccionar.`,
                    type: "400",
                });
                // Restablece el valor anterior de manera reactiva
                this.$nextTick(() => {
                    this.itemDataSelected.tipcontacto = '';
                });
                return;
            }
            // Actualiza los valores si no hay duplicados
            this.itemDataSelected.tipcontacto = value.tcnt_id;
            this.itemDataSelected.destipcontacto = tipoSeleccionado;
        },

        //lo de abajo no se usa
        buscarPorTipContacto() {
            for (let i = 0; i < this.tipoContacto.length; i++) {
                if (this.tipoContacto[i].tcnt_id == this.itemDataSelected.tipcontacto) {
                    this.itemDataSelected['destipcontacto'] = this.tipoContacto[i].tcnt_des_tipcontacto
                    console.log(this.tipoContacto[i].tcnt_des_tipcontacto)
                }
            }
        },
        /**
         * Valida y envía el formulario de mail.
         * Si es modificación, actualiza el mail principal según corresponda.
         * Si es alta, marca como principal si es el único o si se selecciona como tal.
         */
        async submit() {
            const isValid = await this.$refs.obs.validate();
            if (!isValid) {
                this.showSnack({
                    message: `Error al intentar guardar contacto.`,
                    type: "400",
                });
                return;
            }

            this.itemDataSelected.nroafi = this.nroafi;

            // Función auxiliar para desmarcar mails principales
            const desmarcarPrincipales = () => {
                const aux = this.email
                    .filter(e => e.id !== this.itemDataSelected.id)
                    .map(e => ({ ...e, recibeemail: 0, accion: "M" }));
                aux.forEach(mail => this.sendEmail(mail));
            };

            if (this.accion === 'modificar') {
                if (this.itemDataSelected.recibeemail == 1) {
                    desmarcarPrincipales();
                } else if (this.email.length === 0) {
                    this.itemDataSelected.recibeemail = 1;
                } else {
                    this.itemDataSelected.recibeemail = 1;
                }
                this.sendEmail(this.itemDataSelected);
            } else {
                // Alta de mail
                if (this.email.length === 0) {
                    this.itemDataSelected.recibeemail = 1;
                } else if (this.itemDataSelected.recibeemail == 1) {
                    // Si se marca como principal, desmarcar los demás
                    const aux = this.email.map(e => ({ ...e, recibeemail: 0, accion: "M" }));
                    aux.forEach(mail => this.sendEmail(mail));
                } else {
                    this.itemDataSelected.recibeemail = 0;
                }
                this.sendEmail(this.itemDataSelected);
            }
            // Cierra el formulario/modal
            this.$emit('close');
        },
        /* submit() {
            this.$refs.obs.validate().then((result) => {
                if (result) {
                    if (!this.modificacion) {
                        if (this.tipoContactoFiltro.some(e => e == this.itemDataSelected.destipcontacto)) {
                            this.showSnack({
                                message: `Ya existe un email ${(this.itemDataSelected.destipcontacto).toLowerCase()}.`,
                                type: "400",
                            })
                        }
                        else {
                            if ((this.itemDataSelected.recibeemail == true && this.hayEmailPrinc)) {
                                this.showSnack({
                                    message: `Ya existe un email marcado como medio principal.`,
                                    type: "400",
                                })
                            } else {
                                this.itemDataSelected.accion = "A"
                                this.itemDataSelected.recibeemail = (this.itemDataSelected.recibeemail == true) ? 1 : 0
                                this.itemDataSelected.nroafi = this.nroafi
                                this.$emit('contactoGuardado', this.itemDataSelected)
                            }
                        }
                    } else {
                        //actualizacion 21/02/24
                        if (this.initialRecibeEmail !== this.itemDataSelected.recibeemail) {
                            this.showSnack({
                                message: `Ya existe un email marcado como medio principal o no hay ningun telefono marcado como principal.`,
                                type: "400",
                            })
                        } else {
                            if ((this.tipoContactoFiltro.some(e => 3 == this.itemDataSelected.destipcontacto)) &&
                                (this.initialDesTipContacto !== this.itemDataSelected.destipcontacto)) {
                                this.showSnack({
                                    message: `Ya existe un mail ${this.itemDataSelected.destipcontacto}`,
                                    type: "400",
                                })
                            } else {
                                this.itemDataSelected.nroafi = this.nroafi
                                this.itemDataSelected.accion = "M"
                                this.itemDataSelected.recibeemail = (this.itemDataSelected.recibeemail == true) ? 1 : 0
                                this.$emit('contactoGuardado', this.itemDataSelected)
                            }
                        }
                    }
                } else {
                    this.showSnack({
                        message: 'Formulario inválido, no se puede enviar la petición',
                        type: '400'
                    })
                }
    
            });
        }, */
    },
    props: {
        accion: {
            type: String,
            required: true
        }
    }
}

</script>